import { fetchJson } from '@atlassian/jira-fetch/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { IncidentSuggestion } from '../common/types.tsx';
import type { IncidentSuggestionRequestParams } from './types.tsx';
import { transformResponse, transformResponseV2 } from './utils.tsx';

export const getIncidentSuggestionUrl = ({
	cloudId,
	issueId,
	projectId,
	locale,
}: IncidentSuggestionRequestParams): string =>
	`/gateway/api/jsm/aiops/cloudId/${cloudId}/api/v1/incident-suggestion/${issueId}?projectId=${projectId}&locale=${locale}
`;

export const getIncidentSuggestionEndpoint = (
	reqParams: IncidentSuggestionRequestParams,
): Promise<IncidentSuggestion> => {
	const url = getIncidentSuggestionUrl(reqParams);
	return fetchJson(url, {
		method: 'GET',
	}).then(fg('aiops_incident_suggestion_v2') ? transformResponseV2 : transformResponse);
};
